import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { FacebookPage } from '@vendasta/facebook/lib/_internal';
import { SnackbarService } from '@vendasta/galaxy/snackbar-service';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FacebookPagePickerService } from './facebook-page-picker.service';

@Component({
  selector: 'app-facebook-page-picker',
  templateUrl: './facebook-page-picker.component.html',
  standalone: false,
})
export class FacebookPagePickerComponent implements OnInit {
  @Output() selectedPage = new EventEmitter<string>();

  displayedColumns: string[] = ['name', 'id', 'hasPermissions'];
  dataSource$: Observable<FacebookPage[]>;
  permissionsPopoverIsOpen = false;

  constructor(
    private readonly facebookPagePickerService: FacebookPagePickerService,
    private readonly snackbarService: SnackbarService,
    private readonly translate: TranslateService,
  ) {}

  ngOnInit(): void {
    this.dataSource$ = this.facebookPagePickerService.facebookPagesForPartner$.pipe(
      catchError((_) => {
        this.snackbarService.errorSnack(this.translate.instant('LEAD_INTEGRATIONS.FACEBOOK.LOAD_ERROR'));
        return of([]);
      }),
    );
  }

  emitPage(pageId: string): void {
    this.selectedPage.emit(pageId);
  }

  togglePopover(): void {
    this.permissionsPopoverIsOpen = !this.permissionsPopoverIsOpen;
  }
}
